import React from 'react';
import Container from '../Container';
import Styled from './Styled';
const LabelWithDescription = ({ children, description }) => (React.createElement(Container, { display: "flex", flexDirection: "column" },
    children,
    description && React.createElement(Styled.Description, null, description)));
export default LabelWithDescription;
